export default {
      id: "splash-header-usage",
      viewBox: "0 0 1434 304",
      url: __webpack_public_path__ + "redesign-sprite.svg#splash-header-usage",
      toString: function () {
        return this.url;
      }
    }